package gr.tech.site.styles.states

import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.before
import gr.tech.site.util.ImageRepo
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val MichiganHeroTextStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
    }
}

val MichiganHeroStyle = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .background {
                image(url(ImageRepo.Michigan1.src))
                size(BackgroundSize.Cover)
            }
    }
    before {
        Modifier
            .content("")
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .width(100.percent)
            .height(100.percent)
            .backgroundColor(rgba(0, 0, 0, 0.50))
            .zIndex(-1)
    }
}